"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translateToComponent = void 0;
const translations_1 = require("../translations");
const features_1 = require("../features");
const transformers_1 = require("../transformers");
const translateToComponent = (key, values = {}) => {
    const dictionaryHtml = {};
    const dictionaryReact = {};
    const macros = Object.keys(values);
    for (const keyToReplace of macros) {
        const customComponentTag = `custom-component-${(0, features_1.toKebabCase)(keyToReplace).toLowerCase()}`;
        dictionaryHtml[keyToReplace] = `<${customComponentTag}>texto</${customComponentTag}>`;
        dictionaryReact[customComponentTag] = () => values[keyToReplace];
    }
    const htmlResult = macros.length > 0 ? (0, translations_1.translate)(key, dictionaryHtml) : (0, translations_1.translate)(key);
    const transformer = new transformers_1.HtmlToReactTransformer(dictionaryReact);
    return transformer.transform(htmlResult);
};
exports.translateToComponent = translateToComponent;
//# sourceMappingURL=translationToReactComponent.js.map